import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/participantes`;

// En participantesService.js - Agregar logging
export async function getParticipantes(params = {}, userInfo = {}) {
  const { 
    page = 1, 
    pageSize = 20, 
    search = "", 
    estado, 
    municipioId, 
    departamentoId,
    genero 
  } = params;

  const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;

  const queryParams = {
    page, 
    pageSize, 
    search: search || undefined, // 🔥 Asegurar que sea undefined si está vacío
    estado, 
    municipioId, 
    departamentoId,
    genero
  };

  // Limpiar parámetros undefined
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
      delete queryParams[key];
    }
  });
  try {
    const response = await axios.get(baseUrl, {
      params: queryParams,
      headers: {
        "x-usuario-id": usuarioId,
        "x-user-ip": ip,
        "x-usuario-municipio-id": usuarioMunicipioId,
        "x-usuario-es-admin": esAdmin?.toString() || "false"
      }
    });

    return response.data;
  } catch (error) {
    console.error("🔧 SERVICIO - Error en axios:", error);
    throw error;
  }
}
export async function getParticipante(id, userInfo = {}) {
  const { usuarioId, ip } = userInfo;
  
  const response = await axios.get(`${baseUrl}/${id}`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
  return response.data;
}

export async function createParticipante(data, userInfo = {}) {
  const { usuarioId, ip } = userInfo;
  
  return axios.post(baseUrl, data, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

export async function updateParticipante(id, data, userInfo = {}) {
  const { usuarioId, ip } = userInfo;
  
  return axios.put(`${baseUrl}/${id}`, data, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

export async function deleteParticipante(id, userInfo = {}) {
  const { usuarioId, ip } = userInfo;
  
  return axios.delete(`${baseUrl}/${id}`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

// 🔥 NUEVO: Métricas para gráficas
export async function getMetricasParticipantes(userInfo = {}) {
  const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;
  
  const response = await axios.get(`${baseUrl}/metricas`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip,
      "x-usuario-municipio-id": usuarioMunicipioId,
      "x-usuario-es-admin": esAdmin?.toString() || "false"
    }
  });
  return response.data;
}